import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-107bdfa5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "partner" }
const _hoisted_2 = { class: "imagesBox" }
const _hoisted_3 = ["src"]

import Partners1 from "@/assets/images/Partners1.png";
import Partners2 from "@/assets/images/Partners2.png";
import Partners3 from "@/assets/images/Partners3.png";
import Partners4 from "@/assets/images/Partners4.png";
import Partners5 from "@/assets/images/Partners5.png";
import Partners6 from "@/assets/images/Partners6.png";
import Partners7 from "@/assets/images/Partners7.png";
import Partners8 from "@/assets/images/Partners8.png";
import Partners9 from "@/assets/images/Partners9.png";
import Partners10 from "@/assets/images/Partners10.png";
import Partners11 from "@/assets/images/Partners11.png";
import Partners12 from "@/assets/images/Partners12.png";
import Partners13 from "@/assets/images/Partners13.png";
import Partners14 from "@/assets/images/Partners14.png";
import Partners15 from "@/assets/images/Partners15.png";
import { computed, reactive } from "vue";
import { useStore } from "vuex";

export default /*#__PURE__*/_defineComponent({
  __name: 'Partner',
  setup(__props) {

const store = useStore();
const isMobile = computed(() => !!store.state.isMobile as boolean);
const mainImages = reactive([
  Partners1,
  Partners2,
  Partners3,
  Partners4,
  Partners5,
  Partners6,
  Partners7,
  Partners8,
  Partners9,
  Partners10,
  Partners11,
  Partners12,
  Partners13,
  Partners14,
  Partners15,
]);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['partnerBox', { mobileSize: _unref(isMobile) }])
  }, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t("home.partner")), 1),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mainImages, (item, index) => {
          return (_openBlock(), _createElementBlock("img", {
            src: item,
            key: index
          }, null, 8, _hoisted_3))
        }), 128))
      ]),
      (!_unref(isMobile))
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: { path: '/privilege' },
            class: "shadowBtn"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("home.start_free")), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})